// Partenaires.js
import React from 'react';
import './PageContainer.css';


function Partenaires() {
  return (
    <div className="page-container">
      <h1>Programmes partenaires</h1>
      <p>
        Nous offrons aux agences immobilières, promoteurs, investisseurs et acteurs du BTP des partenariats stratégiques transparents et sécurisés.
      </p>
      <h2>Ce que nous proposons :</h2>
      <ul>
        <li>Partage de biens à vendre ou à louer</li>
        <li>Rémunération claire sur les commissions</li>
        <li>Visibilité mutuelle de vos offres sur nos plateformes</li>
        <li>Gestion collaborative sans conflit d’intérêt</li>
        <li>Suivi des dossiers clients communs</li>
      </ul>
      <p><strong>Devenez partenaire :</strong> Contactez-nous pour recevoir une convention de partenariat personnalisée.</p>
    </div>
  );
}

export default Partenaires;